"use strict";

exports.__esModule = true;
exports.BlogPostPath = BlogPostPath;
exports.blogPostRoutes = blogPostRoutes;

var _createRoute = require("../../../../react-static/route/createRoute");

var _Home = require("../Home");

var _formatDateLong = require("../../../../datetime/formatDateLong");

var _getPath = require("../../../../react-static/route/getPath");

function BlogPostPath(postSlug) {
  return "" + _Home.HomePath + postSlug + "/";
}

function blogPostRoutes(rootPath, blogPostsMatter) {
  var postRoutes = blogPostsMatter.map(function (postMatter) {
    var post = {
      title: postMatter.data.title,
      html: postMatter.html,
      postInfo: {
        date: (0, _formatDateLong.formatDateLong)(new Date(postMatter.data.date))
      }
    };
    var path = BlogPostPath(postMatter.data.slug);
    var route = (0, _createRoute.createRoute)(rootPath, path); // Currently using this to check if it is straight markdown read from
    // the content directory, or if it is mdx which has its own layout

    if (postMatter.html) {
      route.component = rootPath + (0, _getPath.getPath)("blogPosts");
    }

    route.getData = function () {
      return {
        path: path,
        post: post
      };
    };

    return route;
  });
  return postRoutes;
}